class EventGroupList {
	constructor() {
		this.init();
	}

	init() {
		this.idIndex = [];
		this.groups = [];
	}
	isEmpty() {
		return 0 < this.idIndex.length;
	}
	add(group) {
		this.idIndex.push(group.id);
		this.groups.push(group);
	}
	getById(id) {
		if (!id) return null;
		let i = this.idIndex.indexOf(id);
		return i === -1 ? null : this.groups[i];
	}
	getOrAddById(id) {
		let group = this.getById(id);
		if (group === null) {
			group = new EventGroup(id);
			this.add(group);
		}
		return group;
	}
	remove(group) {
		let i = this.groups.indexOf(group);
		if (i === -1) return null;
		this.idIndex.splice(i, 1);
		return this.groups.splice(i, 1)[0];
	}
	removeById(id) {
		let i = this.idIndex.indexOf(id);
		if (i === -1) return null;
		this.idIndex.splice(i, 1);
		return this.groups.splice(i, 1)[0];
	}
}